import React from "react";
import "../stylesheets/Header.css";
import { motion } from "framer-motion";

class Header extends React.Component {
  menuClick = () => {
    const menu = document.getElementsByClassName("navbar-toggle");
    const links = document.getElementsByClassName("header-container");

    menu[0].classList.toggle("active");
    links[0].classList.toggle("active");
  };

  render() {
    return (
      <motion.div
        initial={{ y: -100 }}
        animate={{
          y: 0,
          transition: { type: "tween", duration: 1, delay: 0 },
        }}
        className="header-container"
      >
        <motion.div className="header">
          <a href="/# " className="header-logo-link">
            {/* <img src="./WebIcon.png" alt="" className="header-logo" /> */}
            <svg
              className="header-logo"
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              data-name="Layer 1"
              viewBox="0 0 500 499.8"
            >
              <defs>
                <style
                  dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#fff;}" }}
                />
              </defs>
              <circle className="cls-1" cx="249.9" cy="455.64" r="44.16" />
              <circle className="cls-1" cx="249.9" cy="44.16" r="44.16" />
              <circle className="cls-1" cx="44.16" cy="249.16" r="44.16" />
              <circle className="cls-1" cx="455.84" cy="249.16" r="44.16" />
              <path
                className="cls-1"
                d="M439.26,347.41l-7.44-5c-31.35-20.75-40.39-34.92-51-60.05,0-.09-.08-.18-.11-.27a69.75,69.75,0,0,1-.22-53.17q.93-2.28,1.91-4.53c9.95-22.87,19.6-36.65,49.37-56.35l7-4.64c33.78-22.54,40.51-70.27,13-100.12-.62-.68-1.26-1.34-1.91-2a66.63,66.63,0,0,0-27.08-16.49c-28-8.86-58.42,2.65-74.71,27.06l-5,7.44c-20.75,31.35-34.92,40.39-60,51l-.27.11a69.75,69.75,0,0,1-53.17.22c-1.51-.62-3-1.25-4.53-1.91-22.87-10-36.64-19.6-56.35-49.37l-4.69-7C141.5,38.54,93.78,31.87,64,59.42c-.67.62-1.33,1.26-2,1.91A66.59,66.59,0,0,0,45.49,88.38c-8.88,28,2.63,58.44,27.05,74.73l7.44,5c31.35,20.75,40.4,34.92,51,60.05,0,.09.07.18.11.27a69.75,69.75,0,0,1,.21,53.17q-.92,2.28-1.91,4.53c-10,22.87-19.59,36.65-49.37,56.35l-7,4.64c-33.78,22.54-40.5,70.27-13,100.12.62.67,1.25,1.34,1.91,2a66.55,66.55,0,0,0,27.12,16.5c28,8.84,58.39-2.67,74.66-27.07l5-7.44c20.75-31.35,34.92-40.39,60.06-51l.27-.12a69.73,69.73,0,0,1,53.16-.21c1.52.62,3,1.25,4.53,1.91,22.87,9.95,36.65,19.59,56.35,49.37l4.69,7C370.31,472,418,478.64,447.86,451.1c.67-.62,1.33-1.26,2-1.91a66.69,66.69,0,0,0,16.48-27.06C475.19,394.15,463.68,363.7,439.26,347.41ZM372,98.44l4.89-7.32a32.62,32.62,0,0,1,26.67-14.64,29,29,0,0,1,8.78,1.36,32.06,32.06,0,0,1,13.06,8c.31.32.63.65.93,1A30.24,30.24,0,0,1,434,111.1a33,33,0,0,1-14.44,23.54l-7,4.64c-32.18,21.29-46.43,39.05-57.61,62a113.71,113.71,0,0,0-45.13-45.12C333.43,144.59,351,130.11,372,98.44ZM99.09,139.2l-7.34-4.89c-11.91-8-17.37-22.53-13.26-35.46a31.88,31.88,0,0,1,8-13c.32-.32.66-.64,1-1a29.75,29.75,0,0,1,20.48-7.94,32.79,32.79,0,0,1,27.32,14.62l4.68,7c21.3,32.19,39.06,46.43,62,57.61a113.67,113.67,0,0,0-45.1,45.11C145.33,177.85,130.86,160.23,99.09,139.2Zm40.75,272.88L135,419.41A32.63,32.63,0,0,1,108.28,434a29.28,29.28,0,0,1-8.76-1.35,31.93,31.93,0,0,1-13.07-8c-.32-.31-.64-.64-.94-1a30.19,30.19,0,0,1-7.7-24.32,32.93,32.93,0,0,1,14.44-23.54l7-4.64c32.19-21.3,46.43-39.06,57.62-62a113.68,113.68,0,0,0,45.12,45.12C178.37,365.93,160.8,380.42,139.84,412.08ZM255.9,333.5a78.24,78.24,0,1,1,78.24-78.24A78.24,78.24,0,0,1,255.9,333.5Zm177.42,78.16a32,32,0,0,1-8,13c-.33.33-.66.65-1,1a29.73,29.73,0,0,1-20.47,7.94h0A32.79,32.79,0,0,1,376.57,419l-4.69-7c-21.29-32.17-39.05-46.42-62-57.6A113.76,113.76,0,0,0,355,309.23c11.48,23.44,25.95,41.06,57.72,62.09L420,376.2C432,384.16,437.42,398.73,433.32,411.66Z"
                transform="translate(-6 -6.1)"
              />
            </svg>
          </a>
          <h1 className="header-project-title">Particle Interactive</h1>
          <div className="nav-menu-container">
            <div className="navbar-toggle" onClick={() => this.menuClick()}>
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
            <div className="nav-menu">
              <a
                href="/# "
                className="landing-page nav-link"
                onClick={() => this.menuClick()}
              >
                Home
              </a>
              <a
                href="/#devlogs"
                className="dev-log-page nav-link"
                onClick={() => this.menuClick()}
              >
                Dev Log
              </a>
              <a
                href="/#about"
                className="team-members-page nav-link"
                onClick={() => this.menuClick()}
              >
                About Us
              </a>
              <a
                href="https://twitter.com/ParticleInterac"
                className="fab fa-twitter"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(`https://twitter.com/ParticleInterac`, "_blank");
                }}
              >
                <br></br>
              </a>
            </div>
          </div>
        </motion.div>
      </motion.div>
    );
  }
}

export default Header;
